<script setup>

defineProps({
  label: {
    type: String,
    default: ''
  },
  required: Boolean,
  error: Boolean,
  defErrorMsg: {
    type: String,
    default: ''
  },
  errorMsg: {
    type: String,
    default: ''
  },
  helpText: {
    type: String,
    default: ''
  },
  hideLabel: Boolean,
});
</script>

<template>
  <div
    class="form-item"
    :class="[
      {
        'form-item--errors': error,
      },
    ]"
  >
    <div
      v-if="label && !hideLabel"
      class="form-item__label"
    >{{ label }}<span
        v-if="required"
        class="form-item__label-required"
      >*</span>
      <md-popover
        v-if="helpText"
        popper-class="md-normal-popover"
        placement="top"
        trigger="hover"
      >
        <template>
          <div v-html="helpText" />
        </template>
        <md-icon
          slot="reference"
          class="md-icon-question-line"
        />
      </md-popover>
    </div>
    <div class="form-item__content">
      <slot />
      <Transition name="slide-fade">
        <div
          v-if="error"
          class="form-item__content-errors"
        >
          {{ errorMsg || defErrorMsg }}
        </div>
      </Transition>
    </div>
  </div>
</template>

<!-- 组件内只能定义公共样式！ -->
<style scoped lang="less">
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(-4px);
  opacity: 0;
}

.form-item {
  &__content {
    &-errors {
      animation: slide-fade-in 0.3s ease-in;
    }
  }
}

@keyframes slide-fade-in {
  0% {
    opacity: 0;
    transform: translateY(-4px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
